/** Typeahead picker over reusable tag-category schemas (single select).
 *  Returns a `{id, codename, name}` brief (or null). */
import * as tagSchemasApi from '@/api/tagSchemas';
import type { TagCategorySchemaRef } from '@/api/tagCategories';
import { RemoteAutocomplete } from '@/components/RemoteAutocomplete/RemoteAutocomplete';

interface Props {
  value: TagCategorySchemaRef | null;
  onChange: (v: TagCategorySchemaRef | null) => void;
  label?: string;
  size?: 'small' | 'medium';
}

export function TagSchemaPicker({ value, onChange, label = 'Reusable schema', size = 'small' }: Props) {
  return (
    <RemoteAutocomplete<TagCategorySchemaRef>
      label={label}
      size={size}
      fetchOnEmpty
      value={value}
      getOptionLabel={(o) => `${o.name} (${o.codename})`}
      getOptionKey={(o) => o.id}
      queryFn={async (q) =>
        (await tagSchemasApi.list({ search: q, pageSize: 20 })).results.map((s) => ({
          id: s.id,
          codename: s.codename,
          name: s.name,
        }))
      }
      onChange={(v) => onChange((v as TagCategorySchemaRef | null) ?? null)}
    />
  );
}
